import {
  adminClient,
  apiKeyClient,
  inferAdditionalFields,
  oneTapClient,
} from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';
import { clientEnv } from '@/env/client';
import { getBaseUrl } from '@/lib/urls';
import type { auth } from './auth';

/**
 * Better Auth Client Configuration
 * https://www.better-auth.com/docs/integrations/tanstack
 */
export const authClient = createAuthClient({
  baseURL: getBaseUrl(),
  plugins: [
    // https://www.better-auth.com/docs/plugins/admin#add-the-client-plugin
    adminClient(),
    // https://www.better-auth.com/docs/plugins/api-key#add-the-client-plugin
    apiKeyClient(),
    ...(clientEnv.VITE_GOOGLE_CLIENT_ID
      ? [
          oneTapClient({
            clientId: clientEnv.VITE_GOOGLE_CLIENT_ID,
            promptOptions: { fedCM: false },
          }),
        ]
      : []),
    // https://www.better-auth.com/docs/concepts/typescript#inferring-additional-fields-on-client
    inferAdditionalFields<typeof auth>(),
  ],
});
